/**
 * Card rules and configuration constants
 */

// Custom card rules: card numbers with copy limits exceeding 4
export const CARD_RULES = {
  'PR-036': 50,    // Exception: can have up to 50 copies
  'PR-107': 50,    // Exception: Baltan can have up to 50 copies
};

// Transcendent and Semi-Transcendent cards - shows warnings but doesn't affect copy limits
// Transcendent: Cannot be included in official/authorized tournament decks (limit: 0)
// Semi-Transcendent: May be included but only in limited quantities
// Note: 'reasonKey' is a translation key - use t(card.reasonKey) to get localized string
export const TRANSCENDENT_CARDS = {
  'BP01-022': { reasonKey: 'deckConfig.transcendent.reason', limit: 0, type: 'transcendent' },
  'BP01-026': { reasonKey: 'deckConfig.transcendent.reason', limit: 0, type: 'transcendent' },
  'PR-107': { reasonKey: 'deckConfig.semiTranscendent.reason', limit: 8, type: 'semi-transcendent' },
};


// Chart options for deck statistics
export const CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        font: { size: 11 },
        padding: 10,
        usePointStyle: true,
      }
    }
  }
};

// Base bar chart options - max will be set dynamically
export const BAR_CHART_OPTIONS = {
  indexAxis: 'x',
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    }
  },
  scales: {
    y: {
      beginAtZero: true,
      max: 20, // Default, will be overridden dynamically
      ticks: { stepSize: 5 }
    }
  }
};

// Helper to get dynamic bar chart options based on max count
export const getBarChartOptions = (maxCount) => {
  let yMax = 20;
  let stepSize = 5;

  if (maxCount > 20) {
    yMax = 30;
    stepSize = 5;
  }

  return {
    ...BAR_CHART_OPTIONS,
    scales: {
      y: {
        beginAtZero: true,
        max: yMax,
        ticks: { stepSize }
      }
    }
  };
};

// Color palette for pie chart (first two match --brand and --brand-accent)
export const CHART_COLORS = [
  '#3c618a', '#7a67ba', '#dc143c', '#ff6b9d', '#ffa500',
  '#51cf66', '#339af0', '#845ef7', '#d0bfff', '#ffd43b',
  '#ff922b', '#fa5252', '#748ffc', '#b197fc', '#91a7ff'
];
